(function() {
  'use strict';

  angular.module('ringbaPortal').component('eventCallbackWizardForm', {
    bindings: {
      currentCampaign: '<',
      eventCallbacks: '<',
      onDismiss: '&',
      onSave: '&'
    },
    controller: EventCallbackWizardFormController,
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: '/scripts/components/callbacks/event-callback-wizard-form.view.html'
  });

  function EventCallbackWizardFormController(
    _,
    $filter,
    accountsService,
    campaignServiceNew,
    toaster
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onCreateEventCallback = onCreateEventCallback;

    function onInit() {
      vm.createNewEventCallback = !!vm.createNewEventCallback;
    }

    function onChanges(changesObj) {
      if (changesObj.eventCallbacks) {
        if (vm.eventCallbacks.length === 0) {
          vm.createNewEventCallback = true;
        }
      }
    }

    function onCreateEventCallback(eventCallback) {
      return _linkToCampaign(eventCallback.id).then(function () {
        toaster.pop('success', $filter('translate')('PIXEL_CREATE_AND_ADD_SUCCESS'));
        vm.onSave();
        vm.onDismiss({
          $event: {
            eventCallback: eventCallback
          }
        });
      });
    }

    function _linkToCampaign(eventCallBackId) {
      return campaignServiceNew.link(accountsService.currentAccountId, vm.currentCampaign.id, eventCallBackId, 'eventCallBacks');
    }


  }
})();
